(function() {
  const iconsArray = document.querySelectorAll('.press__listItem');

  function toggleContent(event) {
    const currentIcon = event.currentTarget;
    const activeIcon = document.querySelector('.press__listItem--active');
    const activeDescription = document.querySelector('.press__mainContent .press__mainContent--active');
    const currentDescription = document.querySelector(`.press__mainContent [data-id="${currentIcon.dataset.id}"]`);

    activeIcon.classList.remove('press__listItem--active');
    activeDescription.classList.remove('press__mainContent--active');
    currentIcon.classList.add('press__listItem--active');
    currentDescription.classList.add('press__mainContent--active');
  }

  function switchSlide() {
    const pressItems = document.querySelectorAll('.press__listItem');
    const pressItem = document.querySelector('.press__listItem');
    const pressTimer = pressItem.closest('[data-timer]');
    const switcherTimer = pressTimer.dataset.timer > 0 ? pressTimer.dataset.timer * 1000 : 5000;

    if (pressItems.length > 0) {
      setInterval(() => {
        const currentActiveElement = [...pressItems].find(item => item.classList.contains('press__listItem--active'));
        const nextElement = currentActiveElement.nextElementSibling
          ? currentActiveElement.nextElementSibling : pressItem;
        const hoverEvent = new MouseEvent('mouseover');

        currentActiveElement.classList.remove('press__listItem--active');
        nextElement.classList.add('press__listItem--active');
        nextElement.click();
        nextElement.dispatchEvent(hoverEvent);
      }, switcherTimer);
    }
  }

  if (window.innerWidth >= 1280) {
    iconsArray.forEach(icon => {
      icon.addEventListener('mouseover', (event) => toggleContent(event));
    });
  } else {
    iconsArray.forEach(icon => {
      icon.addEventListener('click', (event) => toggleContent(event));
    });
  }

  switchSlide();
})();
